export const USER_ID_SET = 'at/userManagement/workAssignmentPanel/USER_ID_SET'
export const PANEL_TAB_SET = 'at/userManagement/workAssignmentPanel/PANEL_TAB_SET'
export const TASK_IDS_SET = 'at/userManagement/workAssignmentPanel/TASK_IDS_SET'
export const PROJECT_IDS_SET = 'at/userManagement/workAssignmentPanel/PROJECT_IDS_SET'
export const CUSTOMER_IDS_SET = 'at/userManagement/workAssignmentPanel/CUSTOMER_IDS_SET'
export const MANAGE_TASK_IDS_SET = 'at/userManagement/workAssignmentPanel/MANAGE_TASK_IDS_SET'
export const MANAGE_PROJECT_IDS_SET = 'at/userManagement/workAssignmentPanel/MANAGE_PROJECT_IDS_SET'
export const MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET = 'at/userManagement/workAssignmentPanel/MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET'
export const MANAGE_CUSTOMER_IDS_SET = 'at/userManagement/workAssignmentPanel/MANAGE_CUSTOMER_IDS_SET'
export const MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET = 'at/userManagement/workAssignmentPanel/MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET'
export const TASK_TAB_LOADED = 'at/userManagement/workAssignmentPanel/TASK_TAB_LOADED'
export const PROJECT_TAB_LOADED = 'at/userManagement/workAssignmentPanel/PROJECT_TAB_LOADED'
export const CUSTOMER_TAB_LOADED = 'at/userManagement/workAssignmentPanel/CUSTOMER_TAB_LOADED'
export const USER_COUNTERS_SET = 'at/userManagement/workAssignmentPanel/USER_COUNTERS_SET'
export const VIEWER_COUNTERS_SET = 'at/userManagement/workAssignmentPanel/VIEWER_COUNTERS_SET'
export const USER_HAVE_NO_CPT_AT_ALL_SET = 'at/userManagement/workAssignmentPanel/USER_HAVE_NO_CPT_AT_ALL_SET'
export const PANEL_SEARCH_STRING_SET = 'at/userManagement/workAssignmentPanel/PANEL_SEARCH_STRING_SET'
export const PANEL_SEARCH_OPEN_SET = 'at/userManagement/workAssignmentPanel/PANEL_SEARCH_OPEN_SET'

export const PANEL_CLOSE = 'at/userManagement/workAssignmnetsPanel/PANEL_CLOSE'
export const PANEL_OPEN = 'at/userManagement/workAssignmnetsPanel/PANEL_OPEN'
export const LOADED_SET = 'at/userManagement/workAssignmnetsPanel/PANEL_LOADED_SET'
export const LOADING_SET = 'at/userManagement/workAssignmnetsPanel/PANEL_LOADING'
export const SHOW_COPY_SET = 'at/userManagement/workAssignmnetsPanel/SHOW_COPY_SET'

export const COPY_USER_ID_SET = 'at/userManagement/workAssignmnetsPanel/copy/COPY_USER_ID_SET'
export const COPY_LOADING_SET = 'at/userManagement/workAssignmnetsPanel/copy/COPY_LOADING_SET'
export const COPY_ALL_SCOPE_SET = 'at/userManagement/workAssignmnetsPanel/copy/COPY_ALL_SCOPE_SET'
export const COPY_COUNTERS_SET = 'at/userManagement/workAssignmnetsPanel/copy/COPY_COUNTERS_SET'
export const COPY_OPTION_SET = 'at/userManagement/workAssignmnetsPanel/copy/COPY_OPTION_SET'
export const COPY_USER_IDS_FOR_SELECTOR_SET = 'at/userManagement/workAssignmnetsPanel/copy/COPY_USER_IDS_FOR_SELECTOR_SET'

export const COPY_CONTENT_OPEN = 'at/userManagement/workAssignmnetsPanel/copy/COPY_CONTENT_OPEN'
export const COPY_CONTENT_CLOSE = 'at/userManagement/workAssignmnetsPanel/copy/COPY_CONTENT_CLOSE'

export const COPY_VIEWER_HAS_ENTIRE_SCOPE_SET = 'at/userManagement/workAssignmnetsPanel/copy/COPY_VIEWER_HAS_ENTIRE_SCOPE_SET'

export const ASSIGN_ALL_SCOPE_CONTENT_OPEN = 'at/userManagement/workAssignmnetsPanel/copy/ASSIGN_ALL_SCOPE_CONTENT_OPEN'
export const ASSIGN_ALL_SCOPE_CONTENT_CLOSE = 'at/userManagement/workAssignmnetsPanel/copy/ASSIGN_ALL_SCOPE_CONTENT_CLOSE'

export const SET_IS_SHOW_ARCHIVE_ENTITIES = 'at/userManagement/workAssignmnetsPanel/SET_IS_SHOW_ARCHIVE_ENTITIES'



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentPanel/actionTypes.js